import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { from, Observable, switchMap } from 'rxjs';
import { SigningTaskResponse } from '../models/response/SigningTaskResponse';
import { SigningTaskStatusRequest } from '../models/request/SigningTaskStatusRequest';
import { SigningFileRequest } from '../models/request/SigningFileRequest';
import { SigningTaskFileDetailsResponse } from '../models/response/SigningTaskFileDetailsResponse';
import { KeycloakAuthorizationService } from 'src/app/auth/keycloak.authorization.service';

@Injectable({
    providedIn: 'root'
})
export class HttpSigningTaskService {

    private baseApiUrl = this.trimTrailingSlash(environment.signingTasksApi.uri);

    constructor(
        private http: HttpClient
    ) { }

    getSigningTask(referenceCode: string): Observable<SigningTaskResponse> {
        const url = `${this.baseApiUrl}/${referenceCode}`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.get<SigningTaskResponse>(url);
    }

    updateSigningTaskStatus(request: SigningTaskStatusRequest, referenceCode: string): Observable<any> {
        const url = `${this.baseApiUrl}/${referenceCode}/status`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.put<any>(url, request);
    }

    getSigningTaskFile(referenceCode: string): Observable<string> {
        // return from(this.keycloakService.getToken()).pipe(
        //     switchMap(token => {
        //         const url = `${this.baseApiUrl}/${referenceCode}/file`;
        //         const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
        //         return this.http.get(url, { headers , responseType: 'text' }) as Observable<string>;
        //     })
        // );
        return this.http.get(`${this.baseApiUrl}/${referenceCode}/file`, { responseType: 'text' }) as Observable<string>;
    }

    updateSigningTaskFile(request: SigningFileRequest, referenceCode: string): Observable<any> {
        const url = `${this.baseApiUrl}/${referenceCode}/file`;
        // const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` });
        
        return this.http.put<any>(url, request);
    }

    // Ak adresa konci "/", tak ho odstrani
    trimTrailingSlash(url: string): string {
        return url.endsWith('/') ? url.slice(0, -1) : url;
    }
}
